import { useContext, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import ItineraryList from "../../itinerary/itinerary-list/itinerary-list";
import MobileItineraryList from "../../itinerary/mobile-view/itinerary-list";
import { generateDateRangeArray } from "../../../../utils/date";
import { saveItineraryList } from "../../../../store/actions";
import { connect } from "react-redux";
import axios from "axios";
import BASE_URL from "../../../../constants/baseUrls";
import { LocaleContext } from "../../../../routing/LangRouter";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { navigateToLoginPage } from "../../../../utils/utility";
import { IS_MOBILE } from "../../../../constants/breakpoints";

function ViewItinerary({ dispatch }) {
    //general
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const planId = searchParams.get("planId");
    const startDate = searchParams.get("startDate").split("T")[0];
    const endDate = searchParams.get("endDate").split("T")[0];
    const accessToken = localStorage.getItem("accessToken");
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    //get saved itinerary
    const getSavedItinerary = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/itinerary/get_plan/`, {
                params: {
                    plan_id: planId,
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            dispatch(saveItineraryList(response.data));
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                navigateToLoginPage(navigate, locale, location);
                toast.error(t("Toast Messages.Re-login"), { toastId: "custom-id-yes" });
            } else {
                toast.error(t("Toast Messages.Error Occurred"), { toastId: "custom-id-yes" });
            }
        }
    };

    useEffect(() => {
        if (planId) getSavedItinerary();
    }, []);

    return (
        <>
            {IS_MOBILE ? (
                <MobileItineraryList
                    destinationCoordinates="29.62582147009311,52.558446787466316"
                    allDates={generateDateRangeArray(startDate, endDate)}
                />
            ) : (
                <ItineraryList destinationCoordinates="29.62582147009311,52.558446787466316" allDates={generateDateRangeArray(startDate, endDate)} />
            )}
        </>
    );
}

export default connect()(ViewItinerary);
